function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { Animated } from 'react-native';
import { getIconAnimation } from "./iconAnimation";
import { IconRegistryService } from "./service/iconRegistry.service";

/**
 * Animated Icon component.
 *
 * @extends React.Component
 *
 * @method {(callback?: Animated.EndCallback) => void} startAnimation - Toggle animation to start.
 *
 * @method {() => void} stopAnimation - Toggle animation to stop.
 *
 * @property {string} name - A name of icon registered in a specific pack.
 *
 * @property {string} pack - A name of icon pack registered in IconRegistry that is able to provide
 * an icon for a given name.
 *
 * @property {string} animation - Animation name. Can be `zoom`, `pulse`, `shake` or null.
 * Defaults to *zoom*.
 *
 * @property {AnimationConfig} animationConfig - Animation config.
 *
 * @property {any} ...props - Accepts any props
 * depending on the component registered in IconRegistry for a given `name` property.
 * In case of using `@ui-kitten/eva-icons` package, Icon accepts any props for react-native-svg component.
 *
 * @overview-example IconSimpleUsage
 * Icon component provides a simple way to render image by requesting it from an icon set.
 * Icons come with [additional packages](guides/icon-packages),
 * that should be configured before using component.
 * We recommend using [Eva Icons](https://akveo.github.io/eva-icons),
 * to provide a full consistency with Eva Design System.
 *
 * @overview-example IconWithinComponents
 * All UI Kitten components that may contain inner views have support for Eva Icons.
 * When using icons as nested components, icon styles are handled by Eva.
 *
 * @overview-example IconAnimation
 * Icons have 3 types of animations: `zoom`, `pulse` and `shake`.
 *
 * @overview-example IconTheming
 * In particular cases, Icon should be styled in a different way.
 * In case of using Eva Icons it renders [svg images](https://github.com/react-native-community/react-native-svg).
 *
 * In most cases this is redundant, if [custom theme is configured](guides/branding).
 */
export class Icon extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "animation", void 0);

    _defineProperty(this, "startAnimation", callback => {
      var _this$animation;

      (_this$animation = this.animation) === null || _this$animation === void 0 ? void 0 : _this$animation.start(callback);
    });

    _defineProperty(this, "stopAnimation", () => {
      var _this$animation2;

      (_this$animation2 = this.animation) === null || _this$animation2 === void 0 ? void 0 : _this$animation2.stop();
    });

    this.animation = getIconAnimation(props.animation, props.animationConfig);
  }

  componentWillUnmount() {
    var _this$animation3;

    (_this$animation3 = this.animation) === null || _this$animation3 === void 0 ? void 0 : _this$animation3.release();
  }

  render() {
    const _this$props = this.props,
          {
      name,
      pack,
      animation
    } = _this$props,
          iconProps = _objectWithoutProperties(_this$props, ["name", "pack", "animation"]);

    const registeredIcon = IconRegistryService.getIcon(name, pack);
    const iconElement = registeredIcon.icon.toReactElement(iconProps);

    if (!this.animation) {
      return iconElement;
    }

    return /*#__PURE__*/React.createElement(Animated.View, this.animation.toProps(), iconElement);
  }

}

_defineProperty(Icon, "defaultProps", {
  animation: 'zoom'
});